import { render, staticRenderFns } from "./accountsWithdrawals.vue?vue&type=template&id=e85f3b02&"
import script from "./accountsWithdrawals.vue?vue&type=script&lang=js&"
export * from "./accountsWithdrawals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports